// extracted by mini-css-extract-plugin
export default {"biobar-white-tooltip":"styles_biobar-white-tooltip__vIVki","biobar-white-tooltiptext":"styles_biobar-white-tooltiptext__7Kcmx"};